<template>
  <div class="question">
    <h4>{{title}}</h4>
    <div v-html="desc"></div>
  </div>
</template>

<script>
  export default {
    name: 'question',
    props: {
      title: String,
      desc: String,
    }
  }
</script>

<style scoped lang="scss">
  .question {
    margin-bottom: 30px;
    h4 {
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      font-size: 20px;
      line-height: 1.4;
      color: #383838;
      margin-bottom: 10px;
    }
    p {
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      line-height: 1.5;
      color: #383838;
    }
  }

  @media screen and (max-width: 991px) {
    .question {
      margin-bottom: 20px;
    }
  }
</style>
